// extracted by mini-css-extract-plugin
export default {"header":"dialog_header__SWuA6","description":"dialog_description__s-msA","actions":"dialog_actions__RWiVQ","action":"dialog_action__9fLzr","footer":"dialog_footer__2jkCh"};